import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import Store from 'redux/Store'
import setMessage from 'shared/redux/actions/setMessage'
import displayGenError from 'shared/utils/displayGenError'


const syncFilter = async (id: number | string) => {

  await axiosPost(
    apiUrls.filters + '/' + id + '/' + apiUrls.actionSync,
    {},
    (err: AxiosError) => {
      switch (err.response!.status) {
        case 500:
          Store.dispatch(
            setMessage(err.response!.data?.message ?? 'An error occurred', 'error', 'instant'),
          )
          break
        default:
          displayGenError({ setShowOverlay: () => {} })
      }
      return err.response
    },
  ).then((res) => {
    if (res!.status === 200) {
      const successText =
        `Filter #${id} Sync will start in a minute.`
      Store.dispatch(setMessage(successText, 'success', 'instant'))
    }
  })
}

export default syncFilter
